// Nuxt UI v4 preset structure
// This file exports component configurations that will be merged with Nuxt UI defaults
import components from '../components/index.js';
export default {
  // Component configurations follow Nuxt UI's Tailwind Variants API
  ...components
};

